import { useMemo } from 'react';

import { AppSynapseProblemResponse, SynapseProblemID } from '@playq/octopus2-ml';
import { GenericFailure } from '@playq/services-shared';

import { useEitherQuery } from '/api/service-hooks/useEitherQuery';
import { services2 } from '/api/services2';
import { IUseQueryOptionsExtended } from '/api/service-hooks';

import { retrieveProblemQueryKey } from './constants';

export const useProblemRetrieve = (
  id?: SynapseProblemID,
  version?: number,
  options?: IUseQueryOptionsExtended<AppSynapseProblemResponse | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => retrieveProblemQueryKey.concat(id, version), [id, version]);

  const res = useEitherQuery(keys, () => services2.synapseProblemsService.retrieve(id as SynapseProblemID, version), {
    ...options,
    enabled: id !== undefined && options?.enabled !== false,
  });

  return {
    ...res,
    tags: keys,
  };
};
